import React, { useState, useEffect } from 'react';
import {TabsDesc} from './Tabs';
import DescriptionList from './DescriptionList';
import {SearchFilterDesc} from './SearchFilter';
import {SummaryPopupDesc} from './SummaryPopup';
import { api } from '../config/api';
/*
Note on checkbox logic:
1) On submit, everything is rerendered and all columns are set to 'not selected' 
2) on checking different tabs (发布/下架) or changing the filter, the status are kept 
3) when we hit submit we send rows that are 'selected' only 
4) selectall sets all checkboxes on the filteredclasses to isselected. 
  Its changing logic is different from other checkboxes. 
  If it is selected then everytime filter changes/submit/change tab, 
  its status will be different (but that does not affect the individual tabs! 
  only when it changes from not selecte to selected will it affect individual tabs)
*/ 
const DescriptionPage = () => {
  const [classes, setClasses] = useState({ posted: [], to_post: [] });
  const [filteredClasses, setFilteredClasses] = useState({ posted: [], to_post: [] });
  const [selectedTab, setSelectedTab] = useState('to_post');
  const [selectedClasses, setSelectedClasses] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [categories, setCategories] = useState([]);
  const [allSelected, setAllSelected] = useState(false);
  const [selectedMap, setSelectedMap] = useState({});
  
  const URL = api.descriptions;

  useEffect(() => {
    fetch(URL)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        setClasses({
          posted: data.posted || [],
          to_post: data.to_post || []
        });
        setFilteredClasses({
          posted: data.posted || [],
          to_post: data.to_post || []
        });
        extractCategories(data);
      })
      .catch(error => console.error('Error fetching data:', error));
  }, []);

  const extractCategories = (data) => {
    const allCategories = new Set();
    (data.posted || []).concat(data.to_post || []).forEach(cls => {
      if (cls.category) {
        allCategories.add(cls.category);
      }
    });
    setCategories([...allCategories]);
  }


  const handleTabChange = (tab) => {
    setSelectedTab(tab);
    setFilteredClasses({
      ...filteredClasses,
      [tab]: classes[tab] || [] // Ensure the filteredClasses are updated correctly
    });
    updateAllSelectedState(filteredClasses[tab] || []);
  };

  const handleSearchFilter = ({ name, category }) => {
    const LowerName = name.toLowerCase();
    const filtered = {
      posted: (classes.posted || []).filter(cls => cls.name.toLowerCase().includes(LowerName) && (!category || cls.category === category)),
      to_post: (classes.to_post || []).filter(cls => cls.name.toLowerCase().includes(LowerName) && (!category || cls.category === category)),
    };
    setFilteredClasses(filtered);
    updateAllSelectedState(filtered[selectedTab] || []);
  };

  const handleSelectClass = (id, name, is_peak, price, action, isSelected) => {
    const key = `${id}-${is_peak}-${price}`;
    const updatedSelectedMap = {
      ...selectedMap,
      [key]: isSelected
    };
    setSelectedMap(updatedSelectedMap);
    const updatedClasses = {
      ...filteredClasses,
      [selectedTab]: filteredClasses[selectedTab].map(cls =>
        `${cls.id}-${cls.is_peak}-${cls.price}` === key ? { ...cls, isSelected } : cls
      ),
    };
    setFilteredClasses(updatedClasses);
    setSelectedClasses(prevSelected => isSelected 
      ? [...prevSelected, { id, name, is_peak, price, action: selectedTab === 'posted' ? 0 : 1}] 
      : prevSelected.filter(cls => `${cls.id}-${cls.is_peak}-${cls.price}` !== key));
      updateAllSelectedState(updatedClasses[selectedTab]);

    // Calculate allSelected based on the number of true entries in updatedSelectedMap for the current tab
    const currentTabClasses = filteredClasses[selectedTab];
    const selectedCount = currentTabClasses.filter(cls => updatedSelectedMap[`${cls.id}-${cls.is_peak}-${cls.price}`]).length;
    const allSelected = selectedCount === currentTabClasses.length;
    setAllSelected(allSelected);

  };

  const handleSelectAll = (selectAll) => {
    const updatedSelectedMap = { ...selectedMap };
    const updatedClasses = {
      ...filteredClasses,
      [selectedTab]: filteredClasses[selectedTab].map(cls => {
        const key = `${cls.id}-${cls.is_peak}-${cls.price}`;
        updatedSelectedMap[key] = selectAll;
        return { ...cls, isSelected: selectAll };
      }),
    };
    setFilteredClasses(updatedClasses);
    setSelectedMap(updatedSelectedMap);
    setSelectedClasses(selectAll ? filteredClasses[selectedTab].map(cls => ({ id: cls.id, name: cls.name, is_peak: cls.is_peak, price: cls.price, action: selectedTab === 'posted' ? 0 : 1})) : []);
    setAllSelected(selectAll);
  };

  const updateAllSelectedState = (classes) => {
    const allSelected = classes.every(cls => selectedMap[`${cls.id}-${cls.is_peak}-${cls.price}`]);
    setAllSelected(allSelected);
  };

  const handleSubmit = () => {
    console.log(selectedClasses);
    if (selectedClasses.length === 0) {
      alert('提交内容不可为空！\nPlease select at least one entry.');
      return;
    }
    // Clear selected state and reset checkboxes
    setSelectedMap({});
    setAllSelected(false);
    setShowPopup(true);
  };

  const handleConfirm = () => {
    fetch(URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(selectedClasses),
    }).then(() => {
      // Reset everything after submit
      resetState();
      alert("提交成功！");
      // Refresh the page after successful submit
      window.location.reload()
      
    });
  };

  const handleCancel = () => {
    // Reset everything and close popup
    resetState();
  };

  const resetState = () => {
    setSelectedMap({});
    setAllSelected(false);
    setSelectedClasses([]);
    setShowPopup(false);
    setFilteredClasses({
      posted: classes.posted || [],
      to_post: classes.to_post || []
    });
  };

  return (
    <div>
      <SearchFilterDesc onSearchFilter={handleSearchFilter} categories={categories} />
      <TabsDesc selectedTab={selectedTab} onTabChange={handleTabChange} />
      <DescriptionList
        key={selectedTab} // Add key to force re-render on tab change
        classes={filteredClasses[selectedTab]}
        onSelectClass={handleSelectClass}
        onSelectAll={handleSelectAll}
        allSelected={allSelected} // Pass the allSelected state
        selectedMap={selectedMap} // Pass the selectedMap state
      />

      <button className="submit-button" onClick={handleSubmit}>提交</button>
      {showPopup && <SummaryPopupDesc classes={selectedClasses} onConfirm={handleConfirm} onCancel={handleCancel}/>}
    </div>
  );
};

export default DescriptionPage;
